<template>
  <div>
    <el-table
      id="detail-report"
      :key="data.fileName"
	    ref="reportTableModal"
	    :data="data.data"
	    style="width: 100%"
  		:row-class-name="tableRowClassName"
  		:summary-method="getSummaries"
  		:show-summary="data.sum"
	    >
	    <el-table-column
	      v-for="c in data.meta"
	      :prop="c.data"
	      :label="$t(c.name)"
	      :width="c.width"
	      :sortable="c.sortable"
	      :fixed="c.fixed"
        :filters="c.filter"
        :filter-method="c.filter != null ? filterHandler : null">
	      <template slot-scope="scope">
	        <span v-html="processColumnData(scope.row, c.data, c.display, c.type, c)">
	        </span>
	      </template>
	    </el-table-column>
	</el-table>
  </div>
</template>
<script>
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  name: 'Modal',
  props: ['data'],
  watch: {
   "data.data": {
      handler(newVal) {
        let that = this
        this.users = []
        //this.formData = JSON.parse(JSON.stringify(this.item))
        this.data.data.forEach(function(p, i) {
          if (p.owner != null) {
            if (that.users.indexOf(p.owner) == -1)
              that.users.push(p.owner)
          }
        })
        this.users.sort()
        //console.log(newVal)
        this.data.meta.forEach(function(p, i) {
          if (p.filter != null) {
            p.filter = eval('that.' + p.filter)
            //console.log(p.filter)
          }
        })
      },
      deep: true
    }
  },
  data () {
    return {
      users: []
    }
  },
  computed: {
    vacancyStatusFilter: function() {
      let f = []
      for (let i = 0; i < this.vacancyStatus.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.vacancyStatus[i]['c_name'] : this.vacancyStatus[i]['e_name'],
          value = this.vacancyStatus[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    userFilter: function() {
      let f = []
      for (let i = 0; i < this.users.length; i++) {
        f.push({
          'text': this.users[i],
          'value': this.users[i]
        })
      }
      return f
    }
  },
  methods: {
    getSummaries: function(param) {
      const { columns, data } = param;
      const sums = [];
      //console.log(columns)
      columns.forEach((column, index) => {
        let sss = this.data.meta[index].sum
        if (sss == null) {
          sums[index] = ''
          return
        } else if (sss.indexOf('text:') == 0) {
          sums[index] = this.$t(sss.replace('text:', ''))
          return
        }
        const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (sums[index] != 0)
              sums[index] = sums[index].toFixed(2)
            else
              sums[index] = '';
          } else {
            sums[index] = ''
          }
          if (sss.indexOf('calc:') == 0) {
            sums[index] = eval(sss.replace('calc:', '')).toFixed(2)
            return
          }
        })
        
        return sums;
    },
    processColumnData: function(scope, data, display, type, meta) {
      if (display == null) {
        if (type == 'float')
          return eval('scope.' + data).toFixed(2)
        else if (type == 'percent')
          return eval('scope.' + data).toFixed(2) + '%'
        else
          return eval('scope.' + data)
      } else {
        let d = eval('scope.' + data)
        if (display.indexOf('starlinks:') == 0) {
          let s = display.replace('starlinks:', ''),
              id = eval('scope.' + meta.id)
          s = s.replace('{id}', id)
          return '<a href="' + this.STARLINKS_URL + s + '" target="_blank">' + d + '</a>'
        } else if (display.indexOf('router:') == 0) {
          let s = display.replace('router:', ''),
              id = eval('scope.' + meta.id)
          s = s.replace('{id}', id)
          //return '<a href="' + this.BASE_URL + s + '" target="_blank">' + d + '</a>'
          return d
        } else if (display.indexOf('link:') == 0) {
          let s = display.replace('link:', ''),
              id = eval('scope.' + meta.id)
          s = s.replace('{id}', id)
          return '<a href="' + this.BASE_URL + s + '" target="_blank">' + d + '</a>'
        }
        if (d == null)
          return ''
        else
          return eval('this.' + display + '(' + d + ')')
      }
    },
    filterHandler(value, row, column) {
      //console.log(value)
      const property = column['property']
      //console.log(row[property])
      return row[property] === value
    },
    clearFilter() {
      this.$refs.reportTableModal.clearFilter()
    },
    tableRowClassName({row, rowIndex}) {
      if (row.endDate != null) {
        return 'success-row';
      }
      return '';
    },
    exportExcel () {
  	  let wb = XLSX.utils.table_to_book(document.querySelector('#detail-report'))
  	  /* get binary string as output */
  	  let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
  	  try {
  	    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-' + this.data.fileName + '.xlsx')
  	  } catch (e) {
  	    if (typeof console !== 'undefined')
  	      console.log(e, wbout)
  	  }
  	  return wbout
    },
    openVacancy: function() {

    }
  },
  created: function() {
    let that = this
    if (this.data != null)
      this.data.data.forEach(function(p, i) {
        //console.log(p)
        if (p.owner != null) {
          if (that.users.indexOf(p.owner) == -1)
            that.users.push(p.owner)
        }
      })
      this.users.sort()
      this.data.meta.forEach(function(p, i) {
        if (p.filter != null) {
          p.filter = eval('that.' + p.filter)
          //console.log(p.filter)
        }
      })
  }
}
</script>
